import React, { createContext, useContext, useState } from 'react';
import { Snackbar, Stack } from '@mui/material';
import { v4 } from 'uuid';
const SnackbarContext = createContext(undefined);
export const SnackbarProvider = ({ children }) => {
    const [list, setList] = useState([]);
    const showSnackbar = (msg) => {
        setList(prev => [
            ...prev,
            {
                id: v4(),
                message: msg
            }
        ]);
        console.log(list);
    };
    const handleClose = _ => {
        setList(prev => prev.filter(snack => snack.id !== _.id));
    };
    return (<SnackbarContext.Provider value={{ showSnackbar }}>
      {children}
      <Stack spacing={2}>
        {list.map((r, index) => {
            return (<Snackbar key={r.id} open autoHideDuration={3000} sx={{ transform: `translateY(-${index * 70}px) !important` }} // desloca cada um
             onClose={() => {
                    handleClose(r);
                }} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} message={r.message}></Snackbar>);
        })}
      </Stack>
    </SnackbarContext.Provider>);
};
export const useSnackbar = () => {
    const context = useContext(SnackbarContext);
    if (!context) {
        throw new Error('useSnackbar must be used within a SnackbarProvider');
    }
    return context;
};
